/* SEPT VIES — pilote du tiroir panier.
   Toute mutation passe par l'API panier, puis la section est redemandée au
   serveur et le bloc remplacé. Aucun rechargement, et aucun montant recalculé
   côté navigateur : Liquid reste la seule source de vérité pour les prix. */
(function () {
  var SECTION = 'cart-drawer-section';
  var SEL = '[data-sv-cart]';
  var busy = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  /* Toute mutation demande au passage le rendu de la section : l'API panier
     sait le joindre à sa réponse. Un aller-retour au lieu de deux, et surtout
     plus de fenêtre où le tiroir montre l'état d'avant. */
  function post(url, body) {
    body.sections = SECTION;
    return fetch(root() + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  /* Les paliers portent un vrai code de réduction : c'est lui qui fait descendre
     le total côté Shopify, et c'est lui que lira le encaissement en aval. */
  var TIERS = [{ min: 5, code: 'PACK5' }, { min: 3, code: 'PACK3' }];
  function codeFor(n) {
    for (var i = 0; i < TIERS.length; i++) if (n >= TIERS[i].min) return TIERS[i].code;
    return '';
  }
  function syncDiscount(cart) {
    var pots = 0;
    var sub = false;
    var pv = document.querySelector('[data-sv-protect]');
    var pvids = pv ? [String(pv.dataset.variant), String(pv.dataset.variantSub || '')] : [];
    (cart.items || []).forEach(function (it) {
      if (pvids.indexOf(String(it.variant_id)) !== -1) return;
      pots += it.quantity;
      if (it.selling_plan_allocation) sub = true;
    });
    /* Plus aucun code : chaque pack est une variante au prix du pack, et la
       caisse Tagada n'applique de toute façon pas les codes Shopify. On ne fait
       que retirer un code resté accroché à un ancien panier. */
    var want = '';
    void sub; void pots; void codeFor;
    var have = (cart.discount_codes || []).map(function (d) { return d.code; }).join(',');
    if (want === have) return Promise.resolve(cart);
    return post('cart/update.js', { discount: want });
  }

  /* On écrit dans le span « cartBubbleCount », jamais dans son conteneur :
     remplacer le conteneur par du texte détruisait la ref qu'attend le
     composant cart-icon de Horizon (MissingRefError à chaque mise à jour). */
  function bubble(count) {
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (c) {
      c.textContent = count < 100 ? String(count) : '';
      c.classList.toggle('hidden', count === 0);
    });
    document.querySelectorAll('.cart-bubble').forEach(function (b) {
      b.classList.toggle('visually-hidden', count === 0);
    });
  }

  /* Le dernier rendu connu, pour le reposer sans redemander le serveur. */
  var lastHtml = '';

  var verifying = false;

  function render(html) {
    if (!html) return false;
    lastHtml = html;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(SEL);
    var here = document.querySelector(SEL);
    if (!fresh || !here) return false;
    var was = Number(here.getAttribute('data-count'));
    var n = Number(fresh.getAttribute('data-count'));
    here.replaceWith(fresh);
    if (!isNaN(n)) bubble(n);
    document.dispatchEvent(new CustomEvent('sv:cart-rendered'));
    /* Un rendu qui vide un panier qui ne l'était pas est presque toujours une
       course perdue contre le serveur, pas un vrai vidage. On demande confirmation
       une fois — jamais deux, pour ne pas boucler sur un panier réellement vidé. */
    if (n === 0 && was > 0 && !verifying) {
      verifying = true;
      setTimeout(function () {
        refresh().then(function () { verifying = false; }, function () { verifying = false; });
      }, 400);
    }
    return true;
  }

  /* Réponse d'une mutation : la section y est déjà, sous « sections ». */
  function renderFrom(res) {
    var s = res && res.sections;
    return render(s && s[SECTION]);
  }

  /* Le repli, quand aucun rendu n'accompagne l'appel. */
  function refresh() {
    return fetch(root() + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { render(data[SECTION]); });
  }

  function after(res) {
    var cart = res && res.items ? res : null;
    if (cart && typeof cart.item_count === 'number') bubble(cart.item_count);
    return syncDiscount(cart || {}).then(function (out) {
      /* Le rendu le plus frais gagne : celui de la remise s'il y en a eu une,
         sinon celui de la mutation qui vient de passer. */
      if (!renderFrom(out) && !renderFrom(res)) return refresh();
    }).then(function () { busy = false; });
  }

  function change(key, qty) {
    if (busy) return;
    busy = true;
    document.querySelector(SEL) && document.querySelector(SEL).classList.add('is-busy');
    post('cart/change.js', { id: key, quantity: qty }).then(after).catch(function () { busy = false; });
  }

  /* Passer au pack supérieur en abonnement = changer de variante, pas de
     quantité : le pack abonné est une variante dont le prix de base est déjà
     le prix abonné. On ajoute la nouvelle ligne avec son plan, puis on retire
     l'ancienne — dans cet ordre, pour ne jamais montrer un panier vide. */
  function upgrade(key, variantId, qty, planId, gifts) {
    if (busy) return;
    busy = true;
    document.querySelector(SEL) && document.querySelector(SEL).classList.add('is-busy');
    /* Un pack est une unité d'une variante : quantité 1, quel que soit le
       nombre de pots qu'il contient. « qty » ne sert qu'à nommer le pack. */
    void qty;
    var item = { id: Number(variantId), quantity: 1 };
    if (planId) item.selling_plan = Number(planId);
    if (gifts) item.properties = { 'Omaggi': gifts };
    post('cart/add.js', { items: [item] })
      .then(function () { return post('cart/change.js', { id: key, quantity: 0 }); })
      .then(after)
      .catch(function () { busy = false; });
  }

  /* Filet : une variante « Abonnement » arrivée sans plan de vente (URL
     bricolée, ancien panier) serait facturée une seule fois au prix abonné.
     Liquid marque la ligne ; on lui pose son plan avant que quiconque ne paie. */
  document.addEventListener('sv:cart-rendered', function () {
    if (busy) return;
    var li = document.querySelector('[data-sv-needs-plan]');
    if (!li || !li.dataset.key) return;
    busy = true;
    post('cart/change.js', { id: li.dataset.key, selling_plan: Number(li.dataset.svNeedsPlan) })
      .then(after)
      .catch(function () { busy = false; });
  });

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-sv-qty]');
    if (q) {
      var li = q.closest('[data-key]');
      if (li) { e.preventDefault(); change(li.dataset.key, Number(q.dataset.svQty)); }
      return;
    }
    var add = e.target.closest('[data-svc-add]');
    if (add) {
      e.preventDefault(); if (busy) return; busy = true;
      document.querySelector(SEL) && document.querySelector(SEL).classList.add('is-busy');
      post('cart/add.js', { items: [{ id: Number(add.dataset.svcAdd), quantity: 1 }] }).then(after).catch(function () { busy = false; });
      return;
    }
    var up = e.target.closest('[data-sv-upsell]');
    if (up) {
      e.preventDefault();
      if (up.dataset.svUpVariant) upgrade(up.dataset.key, up.dataset.svUpVariant, Number(up.dataset.svUpsell), up.dataset.svUpPlan, up.dataset.svUpGifts);
      else change(up.dataset.key, Number(up.dataset.svUpsell));
    }
  });

  document.addEventListener('change', function (e) {
    var box = e.target.closest('[data-sv-protect-toggle]');
    if (!box || busy) return;
    busy = true;
    var wrap = box.closest('[data-sv-protect]');
    var vid = Number(wrap.dataset.variant);
    if (box.checked) {
      try { sessionStorage.removeItem('sv-protect-refused'); } catch (err) {}
      post('cart/add.js', { items: [protectItem(wrap)] })
        .then(function (res) { if (!renderFrom(res)) return refresh(); })
        .then(function () { busy = false; })
        .catch(function () { busy = false; });
    } else {
      /* Le refus vaut pour la session : sinon la case se recocherait au rendu
         suivant et le client ne pourrait jamais l'enlever. */
      try { sessionStorage.setItem('sv-protect-refused', '1'); } catch (err) {}
      /* Retire la variante réellement présente, unique ou abonnée. */
      var gone = wrap.dataset.variantSub ? [String(vid), String(wrap.dataset.variantSub)] : [String(vid)];
      var upd = {}; gone.forEach(function (g) { upd[g] = 0; });
      post('cart/update.js', { updates: upd }).then(after).catch(function () { busy = false; });
    }
  });

  /* La protection suit le mode du panier : variante « Abonnement » + plan
     dans un panier abonné (refacturée à chaque cycle), « Achat unique » sinon. */
  function protectItem(wrap) {
    var sub = wrap.dataset.mode === 'sub' && wrap.dataset.variantSub;
    var item = { id: Number(sub ? wrap.dataset.variantSub : wrap.dataset.variant), quantity: 1 };
    if (sub && wrap.dataset.plan) item.selling_plan = Number(wrap.dataset.plan);
    return item;
  }

  /* Le panier a changé de mode après l'ajout de la protection : on la remplace
     par la bonne variante. Liquid marque la ligne fautive. */
  document.addEventListener('sv:cart-rendered', function () {
    if (busy) return;
    var wrap = document.querySelector('[data-sv-protect][data-fix-key]');
    if (!wrap) return;
    busy = true;
    post('cart/change.js', { id: wrap.dataset.fixKey, quantity: 0 })
      .then(function () { return post('cart/add.js', { items: [protectItem(wrap)] }); })
      .then(function (res) { if (!renderFrom(res)) return refresh(); })
      .then(function () { busy = false; })
      .catch(function () { busy = false; });
  });

  /* Pré-cochage : une seule fois, jamais après un refus explicite. */
  function preselect() {
    var wrap = document.querySelector('[data-sv-protect]');
    if (!wrap || busy) return;
    if (wrap.dataset.default !== 'true' || wrap.dataset.on === 'true') return;
    var refused = false;
    try { refused = sessionStorage.getItem('sv-protect-refused') === '1'; } catch (err) {}
    if (refused) return;
    busy = true;
    post('cart/add.js', { items: [protectItem(wrap)] })
      .then(function (res) { if (!renderFrom(res)) return refresh(); })
      .then(function () { busy = false; })
      .catch(function () { busy = false; });
  }

  /* Trois moments suffisent : au chargement, après chaque re-rendu, et à
     l'ouverture du tiroir déclenchée par un ajout. Surveiller tout le document
     avec un MutationObserver serait coûteux et exposerait à une boucle. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preselect);
  } else {
    preselect();
  }
  /* Horizon morphe la section en mode « hydration » après un ajout : ce mode
     ne reconstruit pas notre bloc, si bien que le gabarit « panier vide » restait
     affiché alors que le panier contenait des articles. On redemande donc la
     section nous-mêmes à chaque événement panier. */
  var pending = null;
  var second = null;
  function scheduleRefresh() {
    clearTimeout(pending);
    clearTimeout(second);
    pending = setTimeout(function () {
      refresh().then(preselect);
    }, 90);
    /* Horizon rejoue son propre morphing de la section après nous et repose le
       gabarit « panier vide » par-dessus. Cette seconde passe doit redemander
       le serveur, et non reposer le rendu gardé en mémoire : la première passe
       arrive parfois avant que l'ajout ne soit visible côté serveur, et rejouer
       ce rendu-là fige un panier vide alors qu'il contient des articles. */
    second = setTimeout(function () {
      refresh().then(preselect);
    }, 600);
    reconcileSoon();
  }

  /* Dernier filet : Horizon repasse parfois son gabarit « panier vide » après
     nos deux rafraîchissements, sans émettre d'autre événement — le tiroir
     s'ouvre alors vide et sans bouton alors que l'article est bien dans le
     panier (observé une fois sur trois en test). On compare donc, pendant
     cinq secondes, le compte réel du panier au compte affiché par le bloc, et
     on redessine dès qu'ils divergent. Rien n'est fait tant qu'ils concordent. */
  var reconcileTimers = [];
  function reconcile() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var here = document.querySelector(SEL);
        if (!here) return;
        var shown = Number(here.getAttribute('data-count'));
        if (typeof cart.item_count === 'number' && shown !== cart.item_count) {
          return refresh().then(preselect);
        }
      })
      .catch(function () {});
  }
  function reconcileSoon() {
    reconcileTimers.forEach(clearTimeout);
    reconcileTimers = [900, 1800, 3000, 5000].map(function (ms) {
      return setTimeout(reconcile, ms);
    });
  }
  /* Horizon émet « shopify:cart:lines-update » (paquet @shopify/events), pas
     « cart:update ». Les deux anciens noms restent écoutés au cas où un autre
     composant les émettrait encore. */
  var CART_EVENTS = ['shopify:cart:lines-update', 'cart:update', 'cart:refresh'];
  CART_EVENTS.forEach(function (evt) {
    document.addEventListener(evt, scheduleRefresh);
  });
  ['dialog:open', 'theme-drawer:open'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(preselect, 200); });
  });

  /* Filet de sécurité : après un ajout, le tiroir doit s'ouvrir. Horizon le
     fait déjà via son propre gestionnaire ; on ne double l'appel que si le
     panneau est encore fermé, pour ne pas perturber sa séquence. */
  function openDrawer() {
    var d = document.getElementById('cart-drawer');
    if (!d) return;
    var panel = d.querySelector('dialog');
    if (panel && panel.open) return;              // déjà ouvert : on ne touche à rien
    if (typeof d.open === 'function') { d.open(); return; }
    if (panel && typeof panel.showModal === 'function') panel.showModal();
  }
  function maybeOpen(e) {
    /* L'événement Horizon porte « action » et « source » à la racine ; les
       anciens événements les portaient dans « detail ». On lit les deux. */
    var d = (e && e.detail) || {};
    var action = e.action || d.action;
    var src = e.source || d.source;
    if (action && action !== 'add') return;          // retrait ou changement de quantité
    if (src === 'cart-items-component' || src === 'sv-cart') return;
    setTimeout(openDrawer, 120);
  }
  CART_EVENTS.forEach(function (evt) {
    document.addEventListener(evt, maybeOpen);
  });

  /* Compte à rebours jusqu'à la limite d'expédition du jour. Purement
     informatif : au-delà de l'heure, on annonce le lendemain plutôt que de
     faire tourner un faux minuteur qui se réarme. */
  var CUTOFF_H = 14;
  function tickClock() {
    var el = document.querySelector('[data-sv-clock]');
    if (!el) return;
    var now = new Date();
    var end = new Date(now);
    end.setHours(CUTOFF_H, 0, 0, 0);
    var rush = el.closest('[data-sv-rush]');
    if (now >= end) {
      if (rush) rush.innerHTML = rush.innerHTML.replace(/<span>[\s\S]*<\/span>/, '<span>Ordina ora, parte con la prima spedizione di domani</span>');
      return;
    }
    var d = Math.floor((end - now) / 1000);
    var h = Math.floor(d / 3600), m = Math.floor((d % 3600) / 60), sec = d % 60;
    el.textContent = (h ? h + ' h ' : '') + String(m).padStart(2, '0') + ':' + String(sec).padStart(2, '0');
  }
  setInterval(tickClock, 1000);
  document.addEventListener('sv:cart-rendered', tickClock);
  tickClock();

  /* Ouvert au reste du thème : SVDiscount s'en sert pour redessiner le tiroir
     au lieu de recharger la page entière quand il pose un code. */

  /* Recensioni nel carrello: scorrono da sole ogni 4 s, si fermano se la cliente le tocca. */
  (function () {
    var paused = false;
    function tick() {
      if (paused) return;
      var t = document.querySelector('[data-svc-track]');
      if (!t || !t.offsetParent) return;
      var w = t.clientWidth, n = t.children.length, i = Math.round(t.scrollLeft / w);
      t.scrollTo({ left: ((i + 1) % n) * w, behavior: 'smooth' });
      var sc = t.closest('.svc-scroll'); if (sc) sc.scrollLeft = 0;
    }
    document.addEventListener('scroll', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('[data-svc-track]')) return;
      var i = Math.round(t.scrollLeft / t.clientWidth);
      t.parentElement.querySelectorAll('.svc-revs__dots span').forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }, true);
    document.addEventListener('pointerdown', function (e) {
      if (e.target.closest && e.target.closest('[data-svc-track]')) { paused = true; setTimeout(function () { paused = false; }, 8000); }
    });
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) setInterval(tick, 4000);
  })();

  /* Desktop: il pannello si apre sopra la pagina con un velo scuro (sept-vies.css).
     Un tocco sul velo lo chiude, come su Loysie. Si ascolta pointerdown e non click,
     così il clic che apre il carrello non lo richiude subito dopo. */
  document.addEventListener('pointerdown', function (e) {
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    var d = document.getElementById('cart-drawer');
    if (!d || !d.hasAttribute('open') || typeof d.close !== 'function') return;
    var panel = d.querySelector('dialog');
    if (!panel || panel.contains(e.target)) return;
    if (e.target.closest && e.target.closest('dialog[open], [role="dialog"]')) return;
    d.close();
  });

  window.SVCart = { refresh: refresh, render: render };
})();
